<template>
    <div>
        <myHeader></myHeader>
        <div class="nav_wrap_add">
            <div class="nav_wrap">
                <div class="nav">
                    <span :class="{active:item.id==current}" v-for="(item,index) in service_nav" :key="index" @click="changNav(item.id)">{{item.title}}</span>
                </div>
            </div>
        </div>
        <div class="service_data" v-show="id==1 || id==2" :class="{service_data2:id==2}">
            <div class="service_data_nr">
                <div class="data_li">
                    <div class="data_li_b">
                        <count-to :startVal="0" :endVal="parseInt(service_Deatils.year_nums)" :duration="3000"></count-to>
                        <b>+</b>
                    </div>
                    <span v-if="id==1">每年空运量（吨）</span>
                    <span v-else>每年海运量（TEU）</span>
                    <i></i>
                </div>
                <div class="data_li">
                    <div class="data_li_b">
                        <count-to :startVal="0" :endVal="parseInt(service_Deatils.day_nums)" :duration="3000"></count-to>
                        <b>+</b>
                    </div>
                    <span v-if="id==1">单月最高空运量（吨）</span>
                    <span v-else>单月最高海运量（TEU）</span>
                    <i></i>
                </div>
                <div class="data_li">
                    <div class="data_li_b">
                        <count-to :startVal="0" :endVal="parseInt(service_Deatils.country_nums)" :duration="3000"></count-to>
                        <b>+</b>
                    </div>
                    <span v-if="id==1">空运合作开通城市（个）</span>
                    <span v-else>海运合作开通城市（个）</span>
                    <i></i>
                </div>
            </div>
        </div>
        <div class="service_nr" v-html="service_Deatils.content" v-if="service_Deatils.content"></div>
        <el-empty :image-size="160" v-else></el-empty>
        <myFooter></myFooter>
    </div>
</template>

<script>
import myHeader from '../components/header.vue'
import MyFooter from '../components/footer.vue'
import countTo from 'vue-count-to'
export default {
    name: 'service',
    components: {MyFooter, myHeader,countTo},
    data () {
        return {
            id:1,
            service_nav:[],
            current: 1,
            service_Deatils:{}
        }
    },
    created () {
        this.id = this.$route.query.id;
        if(this.id === undefined){
            this.id = 1;
            this.changNav(1);
        }else{
            this.changNav(this.id);
        }
        this.pageData();
    },
    methods: {
        pageData(){
            this.$api.businessList().then(res => {
                this.service_nav = res.data;
            });
        },
        pageDetail(){
            let params = {
                id:this.current
            };
            this.$api.businessDetail(params).then(res => {
                this.service_Deatils = res.data;
            });
        },
        changNav(id){
            this.current = id;
            this.id = id;
            this.pageDetail();
        }


    }
}
</script>

<style scoped>
.nav_wrap_add{width:100%;height:70px;display:block;float:left;}
.nav_wrap{width:100%;height:70px;background:url(../../static/images/sub_navbg.jpg) center no-repeat;background-size:1920px 70px;
    position:fixed;left:0;top:90px;z-index:99;}
.nav{width:1200px;height:70px;display:flex;margin:0 auto;justify-content: center;}
.nav span{width:130px;height:70px;border-bottom:3px solid;border-color:transparent;padding:0 20px;text-align:center;
    font-size:15px;color:#fff;float:left;margin:0 2px;cursor:pointer; align-items: center;justify-content: center;display: inline-flex;
}
.nav span:hover{color:#fff;}
.nav span.active{color:#fff;border-color:#fff;}
.service_data{width:100%;height:240px;display:block;float:left;background:url(../../static/images/service_topbg.png) center no-repeat;
    background-size:1920px 240px;}
.service_data2{width:100%;height:240px;display:block;float:left;background:url(../../static/images/service_topbg2.png) center no-repeat;
    background-size:1920px 240px;}
.service_data_nr{width:1200px;height:240px;display:flex;padding:60px 0;margin:0 auto;justify-content: center;}
.service_data_nr .data_li{width:350px;height:120px;display:inline-block;position:relative;}
.data_li .data_li_b{width:100%;height:60px;display:block;float:left;text-align:center;}
.data_li .data_li_b span{width:auto;height:60px;font-size:48px;color:#fff;line-height:60px;font-weight:bold;display:inline-block;float:none;margin-top:0;}
.data_li .data_li_b b{width:auto;height:60px;font-size:48px;color:#fff;line-height:60px;font-weight:bold;display:inline-block;}
.data_li span{width:100%;height:50px;margin-top:10px;float:left;align-items: center;justify-content: center;font-size:14px;
    display: inline-flex;color:#fff;opacity:0.8;}
.data_li i{width:1px;height:80px;display:block;background:#fff;opacity:0.2;position:absolute;right:0;top:30px;z-index:10;}
.service_data_nr .data_li:nth-child(3) i{display:none;}
.service_nr{width:1200px;height:auto;min-height:500px;float:left;padding:50px 0 60px;position:relative;left:50%;margin-left:-600px;
    font-size:14px;color:#333;line-height:24px;}
.service_nr img{max-width:100%;height:auto;display:block;margin:0 auto;}
@media (min-width:992px) and (max-width:1200px){
    .nav_wrap_add{height:60px;}
    .nav_wrap{height:60px;background:url(../../static/images/sub_navbg.jpg) center no-repeat;background-size:1920px 60px;top:80px;}
    .nav{width:1000px;height:60px;}
    .nav span{width:110px;height:60px;border-bottom:2px solid;border-color:transparent;padding:0 8px;font-size:13px;margin:0 2px;}
    .service_data{height:200px;background:url(../../static/images/service_topbg.png) center no-repeat;background-size:1920px 200px;}
    .service_data2{width:100%;height:200px;background:url(../../static/images/service_topbg2.png) center no-repeat;background-size:1920px 200px;}
    .service_data_nr{width:1000px;height:200px;padding:50px 0;}
    .service_data_nr .data_li{width:300px;height:100px;}
    .data_li .data_li_b{height:60px;}
    .data_li .data_li_b span{height:60px;font-size:32px;line-height:60px;}
    .data_li .data_li_b b{height:60px;font-size:32px;line-height:60px;}
    .data_li span{height:30px;margin-top:10px;font-size:13px;}
    .data_li i{width:1px;height:60px;top:20px;}
    .service_data_nr .data_li:nth-child(3) i{display:none;}
    .service_nr{width:1000px;min-height:400px;padding:40px 0 50px;margin-left:-500px;font-size:14px;line-height:24px;}
}
@media (min-width:768px) and (max-width:991px){
    .nav_wrap_add{height:70px;}
    .nav_wrap{height:70px;background:url(../../static/images/sub_navbg.jpg) center no-repeat;background-size:1920px 70px;top:70px;}
    .nav{width:750px;height:70px;}
    .nav span{width:110px;height:70px;border-bottom:2px solid;border-color:transparent;padding:0 5px;font-size:12px;margin:0 2px;}
    .service_data{height:140px;background:url(../../static/images/service_topbg.png) center no-repeat;background-size:1920px 140px;}
    .service_data2{width:100%;height:140px;background:url(../../static/images/service_topbg2.png) center no-repeat;background-size:1920px 140px;}
    .service_data_nr{width:750px;height:140px;padding:30px 0;}
    .service_data_nr .data_li{width:250px;height:80px;}
    .data_li .data_li_b{height:50px;}
    .data_li .data_li_b span{height:50px;font-size:26px;line-height:50px;}
    .data_li .data_li_b b{height:50px;font-size:26px;line-height:50px;}
    .data_li span{height:20px;margin-top:10px;font-size:12px;}
    .data_li i{width:1px;height:50px;top:15px;}
    .service_data_nr .data_li:nth-child(3) i{display:none;}
    .service_nr{width:750px;min-height:300px;padding:30px 0 40px;margin-left:-375px;font-size:14px;line-height:24px;}
}
@media (max-width:767px){
    .nav_wrap_add{display:none;}
    .nav_wrap{display:none;}
    .service_data{height:120px;background:url(../../static/images/service_topbg.png) center no-repeat;background-size:1920px 120px;}
    .service_data2{width:100%;height:120px;background:url(../../static/images/service_topbg2.png) center no-repeat;background-size:1920px 120px;}
    .service_data_nr{width:100%;height:120px;padding:25px 0;left:0;margin-left:0;}
    .service_data_nr .data_li{width:33%;height:70px;padding:0 15px;}
    .data_li .data_li_b{height:38px;}
    .data_li .data_li_b span{height:38px;font-size:18px;line-height:38px;}
    .data_li .data_li_b b{height:38px;font-size:18px;line-height:38px;}
    .data_li span{height:32px;font-size:12px;margin-top:0;line-height:16px;text-align:center;}
    .data_li i{width:1px;height:40px;top:15px;}
    .service_data_nr .data_li:nth-child(3) i{display:none;}
    .service_nr{width:100%;min-height:200px;padding:20px 15px 30px;margin-left:0;font-size:14px;line-height:24px;left:0;}
}
</style>



// WEBPACK FOOTER //
// src/pages/service.vue